var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0,
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1461_5413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 14H6.5C5.57174 14 4.6815 14.281 4.02513 14.781C3.36875 15.2811 3 15.9594 3 16.6667V18",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11C13.2091 11 15 9.20914 15 7C15 4.79086 13.2091 3 11 3C8.79086 3 7 4.79086 7 7C7 9.20914 8.79086 11 11 11Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1461_5413",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3899 10.365C18.1747 9.60724 19.4219 9.61818 20.1933 10.3896L21.5551 11.7514C22.3338 12.5301 22.3365 13.7919 21.561 14.5739L14.2396 21.9568L11 21.9568C10.4477 21.9568 10 21.5091 10 20.9568L10 17.5L17.3899 10.365Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.2396 21.9568L14.2396 23.9568L15.073 23.9568L15.6597 23.3651L14.2396 21.9568ZM10 17.5L8.61081 16.0612L8 16.6509L8 17.5L10 17.5ZM18.7791 11.8038L20.1409 13.1656L22.9693 10.3372L21.6075 8.97534L18.7791 11.8038ZM20.1409 13.1656L12.8195 20.5485L15.6597 23.3651L22.9811 15.9822L20.1409 13.1656ZM11.3892 18.9388L18.7791 11.8038L16.0007 8.92616L8.61081 16.0612L11.3892 18.9388ZM14.2396 19.9568L11 19.9568L11 23.9568L14.2396 23.9568L14.2396 19.9568ZM12 20.9568L12 17.5L8 17.5L8 20.9568L12 20.9568ZM11 19.9568C11.5523 19.9568 12 20.4045 12 20.9568L8 20.9568C8 22.6136 9.34315 23.9568 11 23.9568L11 19.9568ZM20.1409 13.1656L20.1409 13.1656L22.9811 15.9822C24.5321 14.4182 24.5268 11.8947 22.9693 10.3372L20.1409 13.1656ZM21.6075 8.97534C20.0647 7.43259 17.5703 7.41071 16.0007 8.92616L18.7791 11.8038L18.7791 11.8038L21.6075 8.97534Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-1_1461_5413)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1461_5413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
export default SvgUserEdit;